var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoccerBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22.2688,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_241_43",
    transform: "matrix(0.0154645 0 0 0.0166667 0.0360663 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_241_43",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEXklEQVR4nO2aSYwVRRiAGwVxAhzGsIMhA9Fw48IBuYIHFuEgDDgHSAgHtwCCEyMnYiRhCcNiwgVOHMAQ4GJYjF5RltGQeFEw8YaEHQRlRN5H/vBLmpqq7qrqem+G0F/ykpf33r+9rq76l86ympqampoXFGAcsBzYBZwCfgNuAn36uqmfyXc7gWXA2Ox5AngN+Bg4SxwN4AzwkejKBivARKAHuEc6/gJ2ABOywQIwFFgL3KV53Ac2Aa8MdLBvAD/TOnqBaQMV7GLgjsOxa8Bm3YSuBAR0RWU2qw4bt4F3Wh3sauA/hzNrgFeNnfpbj2DlN+Nycm16q9j+1IfAqlYG27A4cUQ2LofMEOBTPYpM+vS7IQWb4VGLXKPpQfNkGZtX9pE47Ck/E7iUk5X3Mz1lu9WWeaUXVg6sYIMyl9c/wKIsAGAUcEBfoyL+cLFp3kZTQ/SUAgyz7Mbyb7+btRhgieVKn5fjMaWRbss9tD6ZgXB/1lv8+SSV8omO7KkriYE4n7os/kjiMz6F8h7sHE3ifZxPxxw+bUtRCNwrSPdGROiM3rRUfoTaduXe7aE6n6JVTxFLsgD0WLqYk/8DmB2xaRXxQYi+ZwDOlSg/lHmgiUd3QeLR7Uo8LLoOlvj0o4+efkgh7siozCXU5qHnOOV878rUcrqGF+Tv/9PIp6jeAO/hhzPxAOYCl/HnKrCgQN8iTz2d/pEq2pbxod/OKHWrFu5lK8RGQ2X71b7AVk8dPVkowMkSpZLtbJEszJCbqnVrVXrNlFEzvq2WTMvkeEzAvxcolGU61yE3h3TMcdh4u+RWuRgT8A2Hsu+KekzAy3ovVuVaUX4MjAG+ccnGBNxnKPlX+0ovecjuTxDwPs/jTpoEDwzZBykCnhUgOy9BwPMC7M1KEfANQ8mUANlh2mSP5VZIhxLoSLGkL8VeYZWXXDmWA4G23kqxaZ2scphrdyKWxYG2ZJxT+VjaZSjZEyjfpqlnKKXpqsXWVykSj+WGkgsROr6OCPhQhJ1fDB1LUxQPj4DXA3V0RgQceutMsfg5OjhgQad4eb7IAgBGAn8HBCu/HRlo40tDx+kQ+WfQkWWey2buPJBokfKn4eP7qVs867JBgnQqLY289qpKdxhK7yTpDlZE9xhJUPJsSaF4guV4kab84YLX3gR295bY+MlyIdI8LsGTYVco0yvYezPC3tokweZy49Ci/vMsEmBjoK2zSUctgkzedXDlS28WSeBTBXIfd8TaKkQm7zqi9KER44il8ilCfJkfaiMIGUIHNOc2NHG/EB9WZq0AWKEdkDJ+SJDd2ZCh/OrmROdAJu8e97RchUkBOid5rJ5bTV/GLrQlK8PoIqSS2a2N/RnAZC0d2/T9DP1ut6Xqse3GzdmgIh5MKxuBVEHS28+SHz1V0MeTtkcW/S7uauN98D5wCrQDH8oUr8Ko5bRUPZULgVajzfJOfYrgBPArcD33+PB1/eyEFilLo4v3mpqamprs+ecx96fP5Qgm9cYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerBall);
export default __webpack_public_path__ + "static/media/SoccerBall.3c056d51d23b8d1e6699e125537635f5.svg";
export { ForwardRef as ReactComponent };